import { render, staticRenderFns } from "./WarningAlert.vue?vue&type=template&id=5ffc29c9&scoped=true&"
import script from "./WarningAlert.vue?vue&type=script&lang=js&"
export * from "./WarningAlert.vue?vue&type=script&lang=js&"
import style0 from "./WarningAlert.vue?vue&type=style&index=0&id=5ffc29c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffc29c9",
  null
  
)

export default component.exports